import { Badge } from "../common/Brutal";

const CAMP_IMG =
  "https://images.unsplash.com/photo-1655409735952-cb5220efca54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxnbGFtcGluZyUyMHRlbnQlMjBldmVuaW5nfGVufDB8fHx8MTc3ODIxMjc1Mnww&ixlib=rb-4.1.0&q=85";
const TROPIC_IMG =
  "https://images.unsplash.com/photo-1557205070-8ea480699b0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMHN1bnNldCUyMHBhbG0lMjB0cmVlc3xlbnwwfHx8fDE3NzgyMTI3NTN8MA&ixlib=rb-4.1.0&q=85";

export const LandingPricing = () => (
  <section id="zones" className="bg-[#3D1E6D] text-white py-16">
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#FFB400]">
            Camp Pricing
          </div>
          <h2 className="display text-4xl sm:text-5xl mt-2">Choose your home base.</h2>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div
          className="kf-border bg-white text-[#3D1E6D] overflow-hidden"
          style={{ boxShadow: "6px 6px 0 #E5247C" }}
        >
          <img src={CAMP_IMG} className="w-full h-56 object-cover" alt="Tent" />
          <div className="p-6">
            <Badge color="yellow">Tent Pitching · ₱500 / NIGHT</Badge>
            <h3 className="display text-3xl mt-3">Aliw</h3>
            <p className="mt-2 text-[#6B4E9E]">
              Pitch your tent in Aliw Zone — sunrise to starfields. Per tent, per night. Maximum of 4 persons.
            </p>
          </div>
        </div>
        <div
          className="kf-border bg-[#FFB400] text-[#3D1E6D] overflow-hidden"
          style={{ boxShadow: "6px 6px 0 #E5247C" }}
        >
          <img src={TROPIC_IMG} className="w-full h-56 object-cover" alt="Car camping" />
          <div className="p-6">
            <Badge color="magenta">Car + Tent · ₱750 / NIGHT</Badge>
            <h3 className="display text-3xl mt-3">Sigla</h3>
            <p className="mt-2 text-[#3D1E6D]/80">
              Pull up, plug in, and pitch beside your ride. Per tent+car, per night. Maximum of 4 persons.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
